export const getContextInitialState = () => ({
    language: '',
    country: '',
    currency: '',
    view: {
        url: '',
    },
});
